(function () {
    'use strict';

    angular.module('app.shared.services').factory('utilFunctions', ['$window', '$parse',
        function ($window, $parse) {

            var traverseObject = function (obj, func) {
                for (var i in obj) {
                    func.call(undefined, obj[i]);
                    if (obj[i] !== null && typeof (obj[i]) == "object") {
                        // step down in the object tree
                        traverseObject(obj[i], func);
                    }
                }
            };


            var launchImageUrl = function (url) {
                if (url == null) return;
                $window.open(url, "_blank", "menubar=no, status=no, toolbar=no, scrollbars=no, resizable=yes, width=500, height=400, top=200, left=400");
            };


            // NOT USED YET. fires too often
            function trackChanges(objectName, scope) {
                console.log("Now tracking changes for " + objectName);
                scope.$watch(objectName,
                    function (newVal, oldVal) {
                        if (newVal != null) {
                            console.log("MODIFIED.  NEW: ", newVal, "OLD: ", oldVal);
                            scope[objectName].Metadata.IsModified = true;
                        }
                    },
                    true
                );
            }


            var findByProperty = function (array, property, value) {
                var matches = findAllByProperty(array, property, value);
                if (matches.length == 0) return null;
                return matches[0];
            };

            var findAllByProperty = function (array, property, value) {
                if (array == null || array.length === 0) return [];

                var matches = $.grep(array, function (obj) { if (obj == null) return false; return getProp(obj, property) === value; });
                return matches;
            };

            var findByPropertyIgnoreCase = function (array, property, value) {
                if (array == null || array.length === 0) return null;

                var matches = $.grep(array, function (obj) { return getProp(obj, property).toLowerCase() == value.toLowerCase(); });
                if (matches.length == 0) return null;
                return matches[0];
            };

            var getIndexByProperty = function (array, property, value) {
                if (!array) return; //domc added check for certain case that was occuring for Est -> Job
                return array.map(function (element) { return getProp(element, property); }).indexOf(value);
            };


            // assumes the object is an aSa Entity with an "IdentityName" property
            var findByKey = function (array, key) {
                if (array == null || array.length === 0) return null;
                var matches = $.grep(array, function (obj) { return obj[obj.IdentityName] === key; });
                if (matches.length == 0) return null;
                return matches[0];
            };


            // assumes the object is an aSa Entity with an "IdentityName" property
            var getIndexByKey = function (array, object) {
                return getIndexByProperty(array, object.IdentityName, object[object.IdentityName]);
            };


            // - used for sidebar search
            var findIndex = function (array, item) {
                for (var i = 0; i < array.length; i++) {
                    if (angular.equals(array[i], item)) {
                        return i;
                    }
                }
                return -1;
            };


            var sortByProperty = function (array, propertyName) {
                return array.sort(function (a, b) {
                    var valA = a[propertyName];
                    var valB = b[propertyName];
                    return (valA < valB) ? -1 : (valA > valB) ? 1 : 0;
                });

            };

            var isNumeric = function (val) {
                return !isNaN(parseFloat(val)) && isFinite(val);
            };

            var getNumDecimals = function (num) {
                if (Math.floor(num) === Number(num)) return 0;
                if (num.toString().indexOf(".") < 0) return 0;
                return num.toString().split(".")[1].length || 0;
            };


            var roundToNumDecimals = function (val, numDecimals) {
                console.log("Rounding", val, numDecimals);
                console.log(val * Math.pow(10, numDecimals));
                console.log(Math.round(val * Math.pow(10, numDecimals)));
                console.log(Math.pow(10, numDecimals));
                var rounded = Math.round(val * Math.pow(10, numDecimals)) / Math.pow(10, numDecimals);
                return rounded;
            };

            var formatWithCommas = function (x) {
                var parts = x.toString().split(".");
                console.log("parts1", parts);
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                console.log("parts2", parts);
                return parts.join(".");
            };

            var underlineNavIcon = function (icon) {
                switch (icon) {
                    case "HOME":
                        $("#toolArrow").css("visibility", "hidden");
                        $("#reportArrow").css("visibility", "hidden");
                        $("#dashArrow").css("visibility", "hidden");                        
                        break;
                    case "TOOLS":
                        $("#toolArrow").css("visibility", "visible");
                        $("#reportArrow").css("visibility", "hidden");
                        $("#dashArrow").css("visibility", "hidden");
                        break;
                    case "REPORTS":
                        $("#toolArrow").css("visibility", "hidden");
                        $("#reportArrow").css("visibility", "visible");
                        $("#dashArrow").css("visibility", "hidden");
                        break;
                    case "DASH":
                        $("#toolArrow").css("visibility", "hidden");
                        $("#reportArrow").css("visibility", "hidden");
                        $("#dashArrow").css("visibility", "visible");
                        break;
                    case "NONE":
                        $("#toolArrow").css("visibility", "hidden");
                        $("#reportArrow").css("visibility", "hidden");
                        $("#dashArrow").css("visibility", "hidden");
                        break;
                    default:
                        break;
                }
            };


            var objectContainsValues = function (obj) {
                if (obj == null) return false;

                for (var prop in obj) {
                    if (obj[prop] != null) return true;
                }
                return false;
            };


            var removeAllProperties = function (obj) {
                for (var prop in obj) delete obj[prop];
            };


            var handleUnexpectedError = function (error) {
                console.log("Unexpected error:", error);
            };


            // allows dot notation to set child properties
            var setProp = function (obj, propName, value) {
                var value = (value != null) ? value : null;
                var props = propName.split(".");

                for (var i = 0; i < props.length - 1; i++) {
                    if (obj[props[i]] == null) obj[props[i]] = {};
                    obj = obj[props[i]];
                }
                var lastIndex = props.length - 1;
                obj[props[lastIndex]] = value;
            };
            // allows dot notation to access child properties
            var getProp = function (obj, propName) {
                var props = propName.split(".");
                while (props.length && (obj = obj[props.shift()]));
                return obj;
            };


            var setScopeVariable = function (scope, variableName, value) {
                var parsedModel = $parse(variableName);
                var parsedModelAssign = parsedModel.assign;
                parsedModelAssign(scope, value);
            };


            var replaceAll = function (str, find, replace) {
                function escapeRegExp(str) {
                    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
                }

                return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
            };


            var isAString = function (value) {
                return (typeof value === 'string' || value instanceof String);
            };


            return {
                traverseObject: traverseObject,
                trackChanges: trackChanges,
                findByKey: findByKey,
                findByProperty: findByProperty,
                findAllByProperty: findAllByProperty,
                findByPropertyIgnoreCase: findByPropertyIgnoreCase,
                getIndexByKey: getIndexByKey,
                getIndexByProperty: getIndexByProperty,
                findIndex: findIndex,
                sortByProperty: sortByProperty,
                launchImageUrl: launchImageUrl,
                isNumeric: isNumeric,
                getNumDecimals: getNumDecimals,
                roundToNumDecimals: roundToNumDecimals,
                formatWithCommas: formatWithCommas,
                underlineNavIcon: underlineNavIcon,
                objectContainsValues: objectContainsValues,
                removeAllProperties: removeAllProperties,
                getProp: getProp,
                setProp: setProp,
                setScopeVariable: setScopeVariable,
                replaceAll: replaceAll,
                isAString: isAString,

                handleUnexpectedError: handleUnexpectedError
            };

        }
    ]);

})();